export default __webpack_public_path__ + "static/media/warning.c83550b6.png";